import { get_guid } from '../../features/visual-analytics/helpers/misc';
import { TpCanonicalTypeInfo, TpDataContext } from '../interfaces';
import {
  TpActiveEnSelectionFilter,
  TpEnSelectionFilterDefinition,
  TpEnSelectionFilterStep,
  TpEnSelectionFilterStepManual,
  TpEnSelectionFilterTypes,
} from './interfaces';
import { getEnSelectionFilterStep } from './selectionEnFilters';
import { TpUserEnSelectionAction, TpUserEnSelectionActionManual } from './userSelectionActions';

export function getManualEnFilterStep(
  selectionFilter: TpActiveEnSelectionFilter,
  key: string,
): TpEnSelectionFilterStepManual | null {
  const step = getEnSelectionFilterStep(selectionFilter, key);
  if (!step) return null;
  return step as TpEnSelectionFilterStepManual;
}

function handleUserAction(
  state: any,
  dataContext: TpDataContext,
  canonicalTypeInfo: TpCanonicalTypeInfo,
  userSelectionAction: TpUserEnSelectionAction,
) {
  const userSelectionActionManual = userSelectionAction as TpUserEnSelectionActionManual;
  const stepManual: TpEnSelectionFilterStepManual = {
    type: TpEnSelectionFilterTypes.MANUAL,
    description: userSelectionActionManual.description,
    key: userSelectionActionManual.stepIdentifier || get_guid(),
    selectedItemIds: userSelectionActionManual.selectedItemIds,
    stepIdentifier: userSelectionActionManual.stepIdentifier,
  };
  if (userSelectionActionManual.method == 'addFilter') {
    if (userSelectionActionManual.stepIdentifier) {
      const stepIndex = canonicalTypeInfo.selectionFilter.steps.findIndex(
        (step) =>
          step.type == TpEnSelectionFilterTypes.MANUAL &&
          step.stepIdentifier == userSelectionActionManual.stepIdentifier,
      );
      if (stepIndex >= 0) canonicalTypeInfo.selectionFilter.steps[stepIndex] = stepManual;
      else canonicalTypeInfo.selectionFilter.steps.push(stepManual);
    } else canonicalTypeInfo.selectionFilter.steps.push(stepManual);
  } else canonicalTypeInfo.selectionFilter.steps = [stepManual];
}

function performStep(
  dataContext: TpDataContext,
  canonicalTypeInfo: TpCanonicalTypeInfo,
  step: TpEnSelectionFilterStep,
): any[] {
  const stepManual = step as TpEnSelectionFilterStepManual;
  return stepManual.selectedItemIds;
}

function renderContent(
  dataContext: TpDataContext,
  canonicalTypeInfo: TpCanonicalTypeInfo,
  step: TpEnSelectionFilterStep,
) {
  const stepManual = step as TpEnSelectionFilterStepManual;
  return stepManual.description;
}

export const defEnSelectionFilterManual: TpEnSelectionFilterDefinition = {
  handleUserAction,
  performStep,
  renderContent,
};
